import { useEffect, useState } from "react";
import { Bell, CheckCheck, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const KIND_COLOR = { success: "bg-emerald-400", info: "bg-blue-400", error: "bg-red-400" };

export default function DashNotifications() {
  const { t } = useI18n();
  const [items, setItems] = useState(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>;

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-extrabold text-white">{t("dash.notifications")}</h1>
        {items.some((n) => !n.read) && <button onClick={readAll} className="silver-btn !py-2 text-sm" data-testid="mark-all-read"><CheckCheck size={15} /> Mark all read</button>}
      </div>
      {items.length === 0 ? (
        <div className="card-lux p-10 text-center"><Bell className="mx-auto text-slate-600 mb-3" size={32} /><p className="text-slate-400">No notifications yet.</p></div>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className={`card-lux p-4 flex gap-4 ${!n.read ? "border-amber-500/30" : ""}`} data-testid={`notification-${n.id}`}>
              <span className={`h-2 w-2 rounded-full mt-2 shrink-0 ${KIND_COLOR[n.kind] || "bg-slate-400"}`} />
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium text-white text-sm">{n.title}</span>
                  <span className="text-xs text-slate-600">{(n.created_at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                <p className="text-sm text-slate-400 mt-1">{n.message}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
